<p>This Area will Have the Text Area from which the drag and drop to Form Fields will be possible!</p>
